var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play_circle_FILL1_wght400_GRAD0_opsz48 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.09 21.1L20.1 16L12.09 10.9V21.1ZM15 28C13.36 28 11.81 27.685 10.35 27.055C8.89 26.425 7.615 25.565 6.525 24.475C5.435 23.385 4.575 22.11 3.945 20.65C3.315 19.19 3 17.64 3 16C3 14.34 3.315 12.78 3.945 11.32C4.575 9.86 5.435 8.59 6.525 7.51C7.615 6.43 8.89 5.575 10.35 4.945C11.81 4.315 13.36 4 15 4C16.66 4 18.22 4.315 19.68 4.945C21.14 5.575 22.41 6.43 23.49 7.51C24.57 8.59 25.425 9.86 26.055 11.32C26.685 12.78 27 14.34 27 16C27 17.64 26.685 19.19 26.055 20.65C25.425 22.11 24.57 23.385 23.49 24.475C22.41 25.565 21.14 26.425 19.68 27.055C18.22 27.685 16.66 28 15 28Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/playCircle.8608b852caeee196f6843458b4effaf2.svg";
export { ForwardRef as ReactComponent };